import request from "@/CommonDP/utils/request";
export default {
  // 动态表单元数据分组列表
  dynFormGroupList(params) {
    return request.post(`/dynMeta-group/tree`, params).then((res) => res);
  },
  // 异步树形结构前3级
  getRootNodeDataList(parentId) {
    return request.get(`/dynMeta-group/getRootNodeDataList?parentId=${parentId}`).then((res) => res);
  },
  getFormRelatedTable(parentId) {
    return request.get(`/dyn-form/getFormMetaDetails/${parentId}`).then((res) => res);
  },

  queryFormNamePath(formId, formCode) {
    return request.get(`/dyn-form/queryNamePath?formId=${formId}&formCode=${formCode || ""}`).then((res) => res.data);
  },
  exportFile(data = []) {
    return request({
      responseType: "blob",
      url: `/dyn-version/exportGroupMetaFileList`,
      method: "post",
      data
    });
  },
  importFile(data) {
    return request.post("/dyn-version/importMetaFileList", data);
  },
  // 异步树形结构子级
  getChildNodeDataList(parentId, templateType) {
    return request.get(`/dynMeta-group/getChildNodeDataList?parentId=${parentId}&templateType=${templateType}`).then((res) => res);
  },
  // 新增
  addNotTableField(params) {
    return request.post(`/dynMeta-column/addNotTableField`, params).then((res) => res);
  },
  deleteNotTableField(metaId) {
    return request.get(`/dynMeta-column/deleteNotTableField?metaId=${metaId}`).then((res) => res);
  },
  // 新增
  dynFormGroupSave(params) {
    return request.post(`/dynMeta-group/save`, params).then((res) => res);
  },
  deleteGroup(groupId) {
    return request.get(`/dynMeta-group/delete?groupId=${groupId}`).then((res) => res);
  },
  // 编辑
  updateGroup(params) {
    return request.post(`/dynMeta-group/update`, params).then((res) => res);
  },
  // 复制业务模型
  cloneModel(params) {
    return request.post(`/dynMeta-group/clone`, params).then((res) => res);
  },
  columnList(groupId) {
    return request.get(`/dynMeta-column/list?tableName=${groupId}`).then((res) => res);
  },
  // 查询业务模型数据表列表
  queryDynMetaViewTableList(groupId) {
    return request.get(`/dynMeta-group/queryDynMetaViewTableList?groupId=${groupId}`).then((res) => res);
  },
  // 判断两张表是否有关联关系
  queryMasterSlaveRelation(params) {
    return request.post(`/dynMeta-master-slaver/queryMasterSlaveRelation`, params, { title: "数据读取中..." });
  },
  // 字段保存关联子表
  saveSlaveTableField(params) {
    return request.post(`/dynMeta-column/saveSlaveTableField`, params, { title: "保存中..." });
  },
  // 根据表单页面ID查询已经导入得业务模型表
  exportViewTable(params) {
    return request.post(`/dynMeta-group/exportViewTable`, params).then((res) => res);
  },
  queryFormColumns(formId) {
    return request.get(`/dyn-form-design/queryFormColumns/${formId}`).then((res) => res);
  },
  // 业务模型保存
  saveTable(params) {
    return request.post(`/dynMeta-column/saveOrUpdate`, params).then((res) => res);
  },

  queryDynMetaListByGroupID(groupId) {
    return request.get(`/dynMeta-group/queryDynMetaListByGroupID?groupId=${groupId}`).then((res) => res);
  },
  // 业务模型修改
  dynMetaUpdate(params) {
    return request.post(`/dynMeta-group/dynMeta-update`, params).then((res) => res);
  },
  dynMetaDetail(metaId) {
    return request.get(`/dynMeta-group/dynMeta-detail?metaId=${metaId}`).then((res) => res);
  },
  dynMetaDetailByGroupId(groupId) {
    return request.get(`/dynMeta-group/dynMeta-detail?tableName=${groupId}`).then((res) => res);
  },
  dynMetaDelete(params) {
    return request.post(`/dynMeta-group/batchDelete`, params).then((res) => res);
  },
  formDetails(groupId) {
    return request.get(`/dynMeta-column/queryMetaColumns?groupId=${groupId}`).then((res) => res);
  },
  updateMeta(tableNameList) {
    return request.post(`/dynMeta-column/batchUpdate`, tableNameList).then((res) => res);
  },
  dynFormSave(tableNameList) {
    return request.post(`/dyn-form/save`, tableNameList).then((res) => res);
  },
  // 查询当前模块下得动态表单列表
  dynFormList(groupId) {
    return request.get(`/dyn-form/list?groupId=${groupId}`).then((res) => res);
  },
  // 动态表单设计修改
  dynFormUpdate(params) {
    return request.post(`/dyn-form/update`, params).then((res) => res);
  },
  // 批量删除动态表单
  dynFormDelete(params) {
    return request.post(`/dyn-form/batchDelete`, params).then((res) => res);
  },
  queryFormMetaName(formId) {
    return request.get(`/dyn-form/queryFormMetaName?formId=${formId}`);
  },
  // 表单预览保存
  dynamicSave(params, formId) {
    return request.post(`/dyn-common/save/${formId}`, params).then((res) => res);
  },
  // 表单预览修改
  dynamicUpdate(params, formId, primaryKeyValue) {
    return request.post(`/dyn-common/update/${formId}?id=${primaryKeyValue}`, params).then((res) => res);
  },
  cloneForm(json) {
    return request.post(`/dyn-form/clone`, json);
  },
  // 动态标准通用得增删改查接口
  dynamicList(params, id, tabId = "") {
    return request.post(`/dyn-common/list/${id}?tabId=${tabId}`, params).then((res) => res);
  },
  // 动态标准通用得增删改查接口
  dynamicTreeData(params, id) {
    return request.post(`/dyn-common/tree-list/${id}`, params).then((res) => res);
  },
  // 表单详情
  dynamicDetail(params) {
    return request.get(`/dyn-common/detail/${params.formId}?id=${params.primaryKeyValue}`).then((res) => res);
  },
  // 动态表单设计保存
  dynFormDesignSave(params) {
    return request.post(`/dyn-form-design/save/${params.formId}`, params, { title: "表单保存中..." }).then((res) => res);
  },
  // 动态表单设计删除
  dynFormDesignDelete(formId) {
    return request.get(`/dyn-form-design/delete?formId=${formId}`, { title: "设计表单删除中..." }).then((res) => res);
  },
  queryDynFormJson(formId) {
    return request.get(`/dyn-form-design/queryJsonByFormID?formId=${formId}`).then((res) => res);
  },
  queryDynFormAllInfo(formId) {
    return request.get(`/dyn-form-design/detailByFormID?formId=${formId}`).then((res) => res);
  },
  queryDynFormAllInfoByFormCode(formCode) {
    return request.get(`/dyn-form-design/detailByFormCode?formCode=${formCode}`).then((res) => res);
  },
  getFamilyDocPrjId(enterpriseId) {
    return request.get(`/family/new/getFamilyDocByEnterpriseId?enterpriseId=${enterpriseId}`).then((res) => res);
  },
  getFormIdDetail(formId) {
    return request.get(`/dyn-form/details?formId=${formId}`).then((res) => res);
  },
  getListConfigJSONByFormCode(formCode) {
    return request.get(`/dyn-list/queryJsonByFormCode?formCode=${formCode}`);
  },
  querySlaveTableList(tableName) {
    return request.get(`/dynMeta-master-slaver/querySlaveTableList?tableName=${tableName}`);
  },
  updateSlaveTableList(params) {
    return request.post(`/dynMeta-master-slaver/saveOrUpdate`, params);
  },
  delSlaveTableList(id) {
    return request.get(`/dynMeta-master-slaver/delete?id=${id}`);
  },
  querySubformList(id) {
    return request.get(`/dynMeta-master-slaver/queryMasterSlaveList?groupId=${id}`);
  },
  // 标准字段类型
  queryStdFieldTypeList() {
    return request.get(`/dynMeta-column/queryStdFieldTypeList`);
  },
  saveDynMeta(params) {
    return request.post("/dynMeta-group/dynMeta-save", params);
  },

  getPrjIdField(formId) {
    return request.get(`/dyn-form/getPrjIdField/${formId}`);
  },
  customDesignSave(pageId, params) {
    return request.post(`dyn-custom-page/saveOrUpdate/json/${pageId}`, params).then((res) => res);
  },
  // 查询所有得模块列表
  getModuleList(parentId) {
    return request.get(`/dynMeta-group/getModuleList?parentId=${parentId}`);
  },
  // 模块上下移动
  moveUpOrDown(groupId, boolean) {
    return request.get(`/dynMeta-group/moveUpOrDown/${groupId}?moveUp=${boolean}`);
  },
  getCurrentDataPrjId(listPageId, id) {
    return request.get(`/dyn-common/getCurrentDataPrjId/${listPageId}?id=${id}`);
  },
  queryOtherMetaColumnList(data) {
    return request({
      method: "post",
      url: "dynMeta-column/queryOtherMetaColumnList",
      data
    });
  },
  queryExistsSysPermission(formCode) {
    return request.get(`/dyn-form/existsSysPermission/${formCode}`);
  }
};
